import Correlation from "../components/correlation/Correlation";
import Navbar from "../components/navbar/Navbar";



function CorrelationScreen(proops:{}) {
   return (
    <div className="container-fluid bg-theme" style={{ height: "100vh" }}>
      <div className="row h-100">
        <div className="d-flex flex-column align-items-center justify-content-start">
          <div className="w-100 mb-2">
            <Navbar />
          </div>
          <Correlation />
        </div>
      </div>
    </div>
  );
}

export default CorrelationScreen;